import { ElectricMeter, IElectricMeter, IElectricMeterRaw } from '@shared/models/electric-meter';
import { BcmTenantElectricMeterProviderView } from '@shared/models/bcm-tenant-electric-meter-provider-view';

export interface IElectricMeterCabinet {
    id: number;
    handle: string;
    manufacturerHandle: string;
    pierHandle: string;
    keyHandle: string;
    note: string;
    slotsTotal: number;
    slotsOccupied: number;

    apiStatus: string;
    apiStatusMessage: string;
    apiCircuitBreakerTriggered: boolean;
    apiSurgeProtectionTriggered: boolean;
    apiDoorOpen: boolean;
    apiUpdatedOn: Date;

    insertedOn: string;
    insertedBy: string;
    lastUpdateOn: string;
    lastUpdateBy: string;

    provider: BcmTenantElectricMeterProviderView;
    electricMeters: (IElectricMeterRaw | IElectricMeter)[];
}

export class ElectricMeterCabinet {
    id: number;
    handle: string;
    manufacturerHandle: string;
    pierHandle: string;
    keyHandle: string;
    note: string;
    slotsTotal: number;
    slotsOccupied: number;
    hasFreeSlots: boolean;

    apiStatus: string;
    apiStatusMessage: string;
    apiCircuitBreakerTriggered: boolean;
    apiSurgeProtectionTriggered: boolean;
    apiDoorOpen: boolean;
    apiUpdatedOn: Date;

    insertedOn: string;
    insertedBy: string;
    lastUpdateOn: string;
    lastUpdateBy: string;

    provider: BcmTenantElectricMeterProviderView;
    electricMeters: ElectricMeter[];
    hasFreeElectricMeters: boolean;

    constructor(data = {} as IElectricMeterCabinet) {
        this.id = data.id;
        this.handle = data.handle;
        this.manufacturerHandle = data.manufacturerHandle;
        this.pierHandle = data.pierHandle;
        this.keyHandle = data.keyHandle;
        this.note = data.note;
        this.slotsTotal = data.slotsTotal;
        this.slotsOccupied = data.slotsOccupied;
        this.hasFreeSlots = this.slotsTotal - this.slotsOccupied > 0;

        this.apiStatus = data.apiStatus;
        this.apiStatusMessage = data.apiStatusMessage;
        this.apiCircuitBreakerTriggered = data.apiCircuitBreakerTriggered;
        this.apiSurgeProtectionTriggered = data.apiSurgeProtectionTriggered;
        this.apiDoorOpen = data.apiDoorOpen;
        this.apiUpdatedOn = data.apiUpdatedOn;

        this.insertedOn = data.insertedOn;
        this.insertedBy = data.insertedBy;
        this.lastUpdateOn = data.lastUpdateOn;
        this.lastUpdateBy = data.lastUpdateBy;

        this.provider = data.provider ?? null;
        this.electricMeters = (data.electricMeters || []).map(eMeter => new ElectricMeter(eMeter, !!data.provider));
        for (const meter of this.electricMeters) {
            if (!meter.cabinet) {
                meter.cabinet = this;
            }
        }
        this.hasFreeElectricMeters =
            this.electricMeters.length > this.electricMeters.filter(eMeter => eMeter.boats.length > 0).length;
    }
}

